var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.url}},[_c('spa-button',{class:_vm.buttonClass,attrs:{"type":"button"}},[_vm._v("\n    TOPページへ\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }